var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{staticClass:"main-tabs",attrs:{"fixed-tabs":"","optional":"","dark":""}},_vm._l((_vm.links),function(link,index){return _c('v-tab',{key:index,attrs:{"to":link.to}},[_vm._v(" "+_vm._s(link.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }